var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            var AssigneeController = /** @class */ (function () {
                /** @ngInject **/
                function AssigneeController($mdDialog, $filter, minhasTarefasService, tasks, users, resources) {
                    this.$mdDialog = $mdDialog;
                    this.$filter = $filter;
                    this.minhasTarefasService = minhasTarefasService;
                    this.tasks = tasks;
                    this.users = users;
                    this.resources = resources;
                    this.filterBySetor = true;
                    this.cmd = new minhasTarefas.AssigneeTasksCommand();
                    this.cmd.addTasks(tasks);
                }
                AssigneeController.prototype.assignTasks = function () {
                    var _this = this;
                    this.minhasTarefasService.assignTasks(this.cmd)
                        .then(function () {
                        _this.tasks.forEach(function (task) {
                            task.selected = false;
                            // essa linha abaixo dá a ilusão de atualização pelo evento "task:assigned".
                            // É por isso que algumas propriedades das tarefas (claim_date) não mudam quando
                            // há mudança de assignee na tela de tarefas
                            task.assignee = _this.cmd.assignee;
                        });
                        _this.$mdDialog.hide();
                    });
                };
                AssigneeController.prototype.changeAssignee = function () {
                    if (this.assignee) {
                        this.cmd.assignee = this.assignee.login;
                    }
                    else {
                        this.cmd.assignee = null;
                    }
                };
                AssigneeController.prototype.changeFilterBySetor = function () {
                    var _this = this;
                    this.minhasTarefasService.listUsersByResources(this.resources, this.filterBySetor)
                        .then(function (users) {
                        var _a;
                        _this.users.splice(0, _this.users.length);
                        (_a = _this.users).push.apply(_a, users);
                    });
                };
                AssigneeController.prototype.closeDialog = function () {
                    this.$mdDialog.hide();
                };
                AssigneeController.prototype.filterUsers = function (searchText) {
                    var accentInsensitiveOrderBy = this.$filter("accentInsensitiveOrderBy");
                    var accentInsensitiveFilter = this.$filter("accentInsensitiveFilter");
                    return accentInsensitiveOrderBy(accentInsensitiveFilter(this.users, searchText), "value");
                };
                return AssigneeController;
            }());
            minhasTarefas.AssigneeController = AssigneeController;
            angular
                .module("app.tarefas.minhas-tarefas")
                .controller("app.tarefas.minhas-tarefas.AssigneeController", AssigneeController);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
